import React from 'react';

import BookWithArea from '@views/Book/Book/BookWithArea';

import useValues from './hooks';
import Booking from './Booking';

export default function BookMeetingRoom() {
  return <BookWithArea useValues={useValues} Component={Booking} />;
}
